"use strict";

import Page from "./TicketExchange.jsx";

export const auth = true;
export const title = "i18n:ticketExchange.exchangePass";
export const Component = Page;
